import UserModel from "../userModel";

/**
 * @class UserModelBuilder
 * @description Modelo de usuario con los datos basicos para guardar en el local storage
 * NOTA: No agregar más información a este modelo, en caso de precisarlo usarlo para extenderlo.
 */
export default class UserModelBuilder {
  private userModel: UserModel;

  constructor(user?: UserModel) {
    user ? this.userModel = user : this.userModel = new UserModel();
  }

  /**
   * @description Seteamos el identificador del usuario al objeto que se crea.
   * @param {number} id Identificador unico del usuario, ya sea sessionId o userId
   * @returns {UserModel}
   */
  public setId = (id: number): UserModelBuilder => {
    this.userModel.id = id;
    return this;
  };

  /**
   * @description Obtiene el identificador unico del usuario.
   * @returns {number}
   */
  public getId = (): number => this.userModel.id ?? 0;

  /**
   * @description Seteamos el nombre del usuario al objeto que se crea.
   * @param {string} firstName Nombre del usuario.
   * @returns {UserModel}
   */
  public setFirstName = (firstName: string): UserModelBuilder => {
    this.userModel.firstName = firstName;
    return this;
  };

  /**
   * @description Obtengo el nombre del usuario.
   * @returns {string}
   */
  public getFirstName = (): string => this.userModel.firstName.length > 0 ? this.userModel.firstName : '';

  /**
   * @description Seteamos el apellido del usuario
   * @param {string} lastName Apellido del usuario
   * @returns {UserModel}
   */
  public setLastName = (lastName: string): UserModelBuilder => {
    this.userModel.lastName = lastName;
    return this;
  };

  /**
   * @description Obtengo el e-mail del usuario.
   * @returns {string}
   */
  public getEmail = (): string => this.userModel.email.length > 0 ? this.userModel.email : '';

  public setEmail = (email: string): UserModelBuilder => {
    this.userModel.email = email;
    return this;
  };

  /**
   * @description Obtengo el apellido del usuario
   * @returns {string}
   */
  public getLastName = (): string => this.userModel.lastName.length > 0 ? this.userModel.lastName : '';

  /**
   * @description Foto del usuario, si esto no se envia pone las iniciales del anombre y apellido en un circulo.
   * @param {string} path URL de la foto del usuario logeado
   * @returns {UserModel}
   */
  public setPhoto = (path: string): UserModelBuilder => {
    this.userModel.photo = path;
    return this;
  };

  /**
   * @description Obtengo el path de la foto seteada.
   * @returns {string}
   */
  public getPhoto = (): string => this.userModel.photo;

  /**
   * @description Obtengo el objeto UserModel creado.
   * @returns {UserModel}
   */
  public get = (): UserModel => this.userModel;
}
